import { put, take, call } from 'redux-saga/effects';
import { LogoutApi } from '../../api/lelyBackend/logoutApi';
// import { LOCAL_STORAGE_KEYS } from '../../common/constants';
import { resetApplicationStore } from '../../common/redux/purgeStore';
import { logoutRequest } from '../../reducers/userSessionSlice';
import { setRedirect } from '../../reducers/redirectSlice';

/** If detect type: LOGOUT_REQUEST call logoutUser() */
export default function* logoutSaga(api: LogoutApi) {
  while (true) {
    yield take(logoutRequest);
    yield call(logoutUser, api);
  }
}

/** Logout user */
function* logoutUser(api: LogoutApi) {
  try {
    yield call(api.logout);
    // localStorage.removeItem(LOCAL_STORAGE_KEYS.ACCESS_TOKEN);
    yield put(resetApplicationStore());
    // Redirect to logout page which will handle the final logout
    yield put(
      setRedirect({
        destination: '/logout',
      }),
    );
  } catch (error: any) {
    // eslint-disable-next-line no-console
    console.error('Failed to logout:', error);
  }
}
